import axios from "axios";
import authorizeRequest from "./authorize-request";
import getFileName from '../helpers/get-file-name';

export default (filePath) => {
  const fileName = getFileName(filePath);

  return axios
    .get(filePath, {
      ...authorizeRequest(),
      responseType: 'blob'
    })
    .then(({ data }) => {
      const downloadUrl = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', fileName); //any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
};


// WEBPACK FOOTER //
// ./src/helpers/download-file.js